import { render, staticRenderFns } from "./FeaturedBlock.vue?vue&type=template&id=a28a2da2&scoped=true"
import script from "./FeaturedBlock.vue?vue&type=script&lang=js"
export * from "./FeaturedBlock.vue?vue&type=script&lang=js"
import style0 from "./FeaturedBlock.vue?vue&type=style&index=0&id=a28a2da2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a28a2da2",
  null
  
)

export default component.exports